// components/UsuariosModal.js
import React from 'react';

function UsuariosModal({ isOpen, onClose, usuarios, empresaNome, loading }) {
  if (!isOpen) return null;

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal}>
        <div style={modalStyles.header}>
          <h2>Usuários da Empresa: {empresaNome}</h2>
          <button onClick={onClose} style={modalStyles.closeButton}>
            ×
          </button>
        </div>
        
        <div style={modalStyles.content}>
          {loading ? (
            <div style={modalStyles.loading}>Carregando usuários...</div>
          ) : (
            <div style={modalStyles.tableContainer}>
              {usuarios.length === 0 ? (
                <p style={modalStyles.noUsers}>Nenhum usuário encontrado para esta empresa.</p>
              ) : (
                <table style={modalStyles.table}>
                  <thead>
                    <tr>
                      <th style={modalStyles.th}>Nome</th>
                      <th style={modalStyles.th}>Email</th>
                      <th style={modalStyles.th}>Tipo</th>
                      <th style={modalStyles.th}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usuarios.map((usuario) => (
                      <tr key={usuario.idUsuario}>
                        <td style={modalStyles.td}>{usuario.nome || '-'}</td>
                        <td style={modalStyles.td}>{usuario.email}</td>
                        <td style={modalStyles.td}>{formatTipoUsuario(usuario.tipoUsuario)}</td>
                        <td style={modalStyles.td}>
                          <span style={getStatusStyle(usuario.ativo)}>
                            {usuario.ativo ? 'Ativo' : 'Inativo'}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const formatTipoUsuario = (tipo) => {
  const tipos = {
    'MANAGER': 'Gerente',
    'USER': 'Usuário',
    'ADMIN': 'Administrador'
  };
  return tipos[tipo] || tipo;
};

const getStatusStyle = (ativo) => ({
  color: ativo ? '#28a745' : '#dc3545',
  fontWeight: 'bold'
});

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '10px',
    width: '80%',
    maxWidth: '800px',
    maxHeight: '80vh',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
    borderBottom: '1px solid #e9ecef',
    backgroundColor: '#f8f9fa',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#6c757d',
  },
  content: {
    padding: '20px',
    maxHeight: '60vh',
    overflowY: 'auto',
  },
  loading: {
    textAlign: 'center',
    padding: '40px',
    color: '#666',
  },
  noUsers: {
    textAlign: 'center',
    color: '#6c757d',
    fontStyle: 'italic',
  },
  tableContainer: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    padding: '12px',
    textAlign: 'left',
    borderBottom: '2px solid #dee2e6',
    fontWeight: 'bold',
    backgroundColor: '#f8f9fa',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #dee2e6',
  },
};

export default UsuariosModal;